import React from 'react';
import './Maintenance.scss';

export default function Maintenance() {
    return (
        <div className='maintenance'>
            <picture>
                <source srcSet={'/assets/logo_transparent.webp'} type="image/webp" />
                <img src={'/assets/logo_transparent.png'} alt="Logo Grandir & s'élever ensemble" loading="eager" fetchpriority="high" />
            </picture>
            <p>Le site est actuellement en <b>maintenance</b>, merci de revenir dans quelques minutes.</p>
        </div>
    )
}
